import { Injectable } from '@angular/core';
import { GlobalVariable } from 'app/main/globals';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URLSearchParams } from 'url';
// import { AspMyRequestService } from '../asp-my-request/asp-my-request.service'


@Injectable({
  providedIn: 'root'
})
export class MyJobCardsDetailsService {


  constructor(
    private http: HttpClient,
    // private aspMyRequestService: AspMyRequestService // Inject the aspMyRequestService

  ) { }


  getJobCardDetails(bookingId: number, garageKey: string, jobCardId: number) {
    const paramData = {
      bookingId,
      garageKey,
      jobCardId,
      source: "web"
    };
    console.log("PARAM DATA OF JOBCARD DETAILS---",paramData)
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` + '/booking/v1/jobCard/detail', paramData);
  }
  // getMyRequest(spareUserKey: string, garageKey: string): Observable<any> {
  //   return this.aspMyRequestService.myRequest(spareUserKey, garageKey);
  // }

  getPreFilledBooking(registrationNumber: string, garageKey: string): Observable<any> {
    console.log('-----Fetching Pre-Filled Booking-----------');
    const requestBody = {
      registrationNumber: registrationNumber,
      garageKey: garageKey
    };
  
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/booking/v1/preFilledBooking`, requestBody);
  }
  updateStatus(payload: any){
    const paramData=payload;
  
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/garage/jobcardListStatus`, paramData);
  }
  submitData1(payload: any) {
    const paramData=payload;
    console.log("paramData",JSON.stringify(paramData))
    return this.http.post(`${GlobalVariable. BASE_API_URL_SPARES}/garageManagement/v1/createInvoice`, paramData);
}
submitDataUpdate(payload: any){
  const paramData=payload;
  console.log('-----submitDataUpdate-----------');    
  return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/garage/customer/quote/update`, paramData);

}
updateCheckIn(payload: any){
  const paramData=payload;
  // console.log(this.paramData);
  console.log('-----updateCheckIn-----------');    
  return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` + '/booking/v1/updateCheckInReport',paramData);
}
getPartNameSuggestions(variantKey: string, partNames: string) {
  console.log('-----getPartNameSuggestions API call------');
  return this.http.get(
    `https://elastic.testpitstop.com/elasticsearch/api/v1/part-name-suggestions-elk?relevancy=true&variant=${variantKey}&partNames=${encodeURIComponent(partNames)}`,
    {
      headers: {
        'x-api-key': '0685c929fe579454904f6ca97a6ab0b3',
      },
    }
  );
}

createB2BRequest(rowKey: string, make: string, model: string, fuelType: string, vinNo: string, variantKey: string, variant: string, manufacturingYear: string, regNo: string, notes: string, jobCardId, items: any, spareRequestId) {
  let spareGarageId = localStorage.getItem('merchantId');

    // URL Parameters
    let params = new HttpParams()
      .set('rowKey', rowKey)
      .set('make', make)
      .set('model', model)
      .set('fuelType', fuelType)
      .set('vinNo', vinNo)
      .set('variantKey', variantKey)
      .set('variant', variant)
      .set('manufacturingYear', manufacturingYear)
      .set('regNo', regNo)
      .set('spareGarageId', spareGarageId)
      .set('jobCard', jobCardId)
      .set('userType', 'pitstopspare')
      .set('requestType', 'web')
      .set('notes', notes);

      if(spareRequestId!='' && spareRequestId>0){
        params = params.set('requestId', spareRequestId);
      }

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const paramData = new HttpParams()
        .set('data', JSON.stringify({
            items: items
        }));

    return this.http.post(`${GlobalVariable.BASE_API_URL}/b2bcreatesparerequest`, paramData, { headers, params });

}
searchB2BLineItem(searchTerm: string) {
  const spareGarageId = localStorage.getItem('spareGarageId');

  const sessionPost = {
    spareGarageId: spareGarageId,
    userType: 'pitstopspare',
    search: searchTerm,
    type: ''
  };

  const headers = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded'
  });

  const body = new HttpParams()
    .set('sessionPost', JSON.stringify(sessionPost));

  return this.http.post(`${GlobalVariable.BASE_API_URL}/pitstop/b2bsearchlineitem`, body, { headers });
}


setRequestId(garageKey, b2bRequestId, jobCardId) {
    const paramData = {
      garageKey: garageKey,
      jobCardId: jobCardId,
      b2bRequestId: b2bRequestId,
      source: "web"
    };
    
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` + '/booking/v1/jobcard/requestId', paramData);
  }

getStateList(): Observable<any> {
  console.log('-----Fetching State List-----------');
  return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}/states/v1/stateList`);
}


}